"use client"

/* eslint-disable react/no-unescaped-entities */
import { useState } from "react";
import {
  Accordion,
  AccordionHeader,
  AccordionBody,
} from "@material-tailwind/react";

interface IconProps {
    open: boolean;
}

function Icon({ open }: IconProps): React.ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={`${
        open ? "rotate-180" : ""
      } h-4 w-4 transition-transform`}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

interface FaqAccordionProps {
    questions?: { id: number, question: string, answer: React.ReactElement }[];
}

const FaqAccordion = ({ questions = [] }: FaqAccordionProps) => {
  const [currentlyOpen, setCurrentlyOpenedItem] = useState(0);

  const handleOpen = (value: number) => {
    setCurrentlyOpenedItem(currentlyOpen === value ? 0 : value);
  };

  return (
    <>
      {questions.map((q) => (
        <Accordion
          placeholder=""
          className="accordion-item mb-5 overflow-hidden rounded-lg border border-jacarta-100 dark:border-jacarta-600 h-auto"
          key={q.id}
          open={currentlyOpen === q.id}
          icon={<Icon open={currentlyOpen === q.id} />} 
          onPointerEnterCapture={() => {}} 
          onPointerLeaveCapture={() => {}}>
          <AccordionHeader
            placeholder=""
            className="accordion-button collapsed relative flex w-full items-center justify-between bg-white px-4 py-3 text-right text-sm text-jacarta-700 dark:bg-jacarta-700 dark:text-white lg:text-sm text-md"
            onClick={() => handleOpen(q.id)}
            onPointerEnterCapture={() => {}}
            onPointerLeaveCapture={() => {}}>
            {q.question}
          </AccordionHeader>
          <div className="hidden-style">
            <AccordionBody className="accordion-body border-t border-jacarta-100 bg-white p-4 dark:border-jacarta-600 dark:bg-jacarta-700 dark:text-white lg:text-sm text-md">
              {q.answer}
            </AccordionBody>
          </div>
        </Accordion>
      ))}
    </>
  );
};

export default FaqAccordion;
